import React from 'react';
import styles from './style.css';

const DropDown = ({options, onChange, value, label, disabled=false, name='',
                      style='', labelStyle='', selectStyle='', optionStyle='', viewedByAdministrator=false}) => {
    let formattedOptions = []
    if(options[0].hasOwnProperty('value')){
        if(options[0].hasOwnProperty('label')) {
            formattedOptions = options
        }
        else {
            options.forEach(op => op.hasOwnProperty('disabled') &&
            op.disabled===true && viewedByAdministrator===false ?
                formattedOptions.push({value: op.value, label: op.label, disabled: true}) :
                formattedOptions.push({value: op.value, label: op.label, disabled: false}))
        }
    }
    else{
        options.forEach(op => op.hasOwnProperty('disabled') &&
        op.disabled===true && viewedByAdministrator===false ?
            formattedOptions.push({value: op, label: op, disabled: true}) :
            formattedOptions.push({value: op, label: op, disabled: false}))
    }
    return (
        <div className={`${styles.inputForm} ${style}`}>
            {label !== undefined &&
                <label className={`${styles.label} ${labelStyle}`}>
                    {label}
                </label>
            }
            <select className={`${styles.select} ${selectStyle}`}
                    name={name}
                    value={value}
                    onChange={onChange}
                    disabled={disabled}
            >
                {formattedOptions.map((f, i) => {
                    if(f.disabled && !viewedByAdministrator) {
                        return (
                            <option disabled className={`${styles.option} ${optionStyle}`} value={f.value} key={i}>
                                {f.label}
                            </option>
                        )
                    } else {
                        return (
                            <option className={`${styles.option} ${optionStyle}`} value={f.value} key={i}>
                                {f.label}
                            </option>
                        )
                    }
                })}
            </select>

        </div>
    );
}

const InputField = ({onChange, value, label, type='text', required=false, disabled=false, name='', placeholder='', style='', inputStyle='', valid = true, ...rest}) => {
    let isValid = valid && (!required || value)
    let props = {
        className: `${styles.input} ${(!isValid) && styles.required} ${inputStyle}`,
        name: name,
        value: value,
        placeholder: placeholder,
        onChange: onChange,
        disabled: disabled
    }
    if(type !== 'textarea') {
        props.type = type
    }
    return (
        <div className={`${styles.inputForm} ${style}`}>
            {label !== undefined &&
                <label className={styles.label}>
                    {label}
                </label>
            }
            {type === 'textarea' ?
                <textarea {...props} {...rest}/> :
                <input {...props} {...rest}/>
            }
        </div>
    );
}

const Checkbox = ({onChange, checked, label, disabled=false, name='', style='', inputStyle=''}) => {
    return (
        <div className={`${styles.checkboxInput} ${style}`}>
            <input className={`${styles.checkBox} ${inputStyle}`}
                   type='checkbox'
                   name={name}
                   checked={checked}
                   onChange={onChange}
                   disabled={disabled}
            />
            {label !== undefined &&
            <label className={styles.checkboxLabel}>
                {label}
            </label>
            }

        </div>
    );
}

export {DropDown, InputField, Checkbox};


// WEBPACK FOOTER //
// ./src/components/InputForms/index.js